import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { CheckCircle, Loader2, XCircle } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const VerifyEmail = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('checking');
  const [message, setMessage] = useState('');

  useEffect(() => {
    const token = params.get('token');
    if (!token) { setStatus('error'); setMessage('Token mancante'); return; }
    axios.post(`${API}/auth/verify-email`, { token }, { withCredentials: true })
      .then(() => { setStatus('success'); })
      .catch((e) => { setStatus('error'); setMessage(e.response?.data?.detail || 'Errore verifica'); });
    // `API` and `axios` are module-level constants and not reactive — intentionally excluded.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);

  return (
    <div className="min-h-screen bg-[#FAFAFA] flex items-center justify-center p-6">
      <Card className="max-w-md w-full bg-white border border-slate-200 rounded-xl shadow-lg" data-testid="verify-email-card">
        <CardContent className="p-12 text-center">
          {status === 'checking' && (
            <>
              <Loader2 className="w-16 h-16 text-[#EA580C] mx-auto mb-6 animate-spin" />
              <h2 className="text-2xl font-semibold text-[#0F172A] mb-2">Verifica in corso...</h2>
            </>
          )}
          {status === 'success' && (
            <>
              <CheckCircle className="w-16 h-16 text-green-600 mx-auto mb-6" />
              <h2 className="text-2xl font-semibold text-[#0F172A] mb-2">Email verificata!</h2>
              <p className="text-slate-600 mb-6">Ora puoi accedere alla tua area personale.</p>
              <Button data-testid="goto-dashboard-btn" onClick={() => navigate('/dashboard')} className="bg-[#EA580C] hover:bg-[#EA580C]/90 text-white rounded-lg">
                Vai alla Dashboard
              </Button>
            </>
          )}
          {status === 'error' && (
            <>
              <XCircle className="w-16 h-16 text-red-500 mx-auto mb-6" />
              <h2 className="text-2xl font-semibold text-[#0F172A] mb-2">Verifica fallita</h2>
              <p className="text-slate-600 mb-6">{message}</p>
              <Button data-testid="back-home-btn" onClick={() => navigate('/')} variant="outline">
                Torna alla home
              </Button>
            </>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default VerifyEmail;
